import React, { FC } from "react";
import { ResourceTypeLink } from "@evergis/api";
import { useSelector } from "react-redux";

import { LayerCopy } from "./Layer/LayerCopy";
import { ProjectCopy } from "./Project/ProjectCopy";
import { TableCopy } from "./Table/TableCopy";

import { dialogResourceTypeSelector } from "../../../../ducks/dialogs/selectors";

export const CopyResource: FC = () => {
  const resourceType = useSelector(dialogResourceTypeSelector);

  switch (resourceType) {
    case ResourceTypeLink.Project:
      return <ProjectCopy />;
    case ResourceTypeLink.Layer:
      return <LayerCopy />;
    case ResourceTypeLink.Table:
      return <TableCopy />;
    default:
      return null;
  }
};
